import React from 'react'
import profile2 from "../../assets/images/about/profile2.png"
import { RiLinkedinBoxFill, RiMailSendLine } from '@remixicon/react'
import SlideUp from '../../utlits/animations/slideUp'
const Summery = () => {
    return (
        <section id="about" className="about-single-area innerpage-single-area">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4">
                        <SlideUp>
                            <div className="about-image-part">
                                <img src={profile2} className="profile-picture" alt="About Me" />
                            </div>
                        </SlideUp>
                    </div>
                    <div className="col-lg-8">
                        <SlideUp>
                            <div className="about-content-part">
                                <h2>
                                    Marco Zúñiga, desarrollador y creador
                                </h2>
                                <p>Soy desarrollador Fullstack con conocimientos tanto de frontend como de backend. A lo largo de los últimos años, he gestionado proyectos completos, desde la arquitectura hasta la implementación final pasando por el desarrollo y las pruebas.</p>
                                <p>Además, soy experto en marketing digital y redes sociales. Durante los últimos 10 años he combinado mis conocimientos técnicos con estrategias de marketing para ayudar a marcas y empresas a crecer en el entorno online..</p>
                                <div className="hero-btns">
                                    <a href="https://www.linkedin.com/in/marcozcuadrado/" className="theme-btn">Conectar<i> <RiLinkedinBoxFill size={16} /></i></a>
                                </div>
                            </div>
                        </SlideUp>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Summery